import React from "react";
import {
  Alert,
  Form,
  FormFeedback,
  Input,
  Label,
  ModalBody,
  Spinner
} from "reactstrap";
import SelectRegion from "./SelectRegion";

const PaymentForm: React.FC<{
  toggle: () => void;
  loading: boolean;
  isUpdate?: boolean;
  validation: any;
  fieldErrors: any;
}> = ({ validation, toggle, isUpdate, loading, fieldErrors }) => {
  return (
    <Form
      className="tablelist-form"
      onSubmit={(e) => {
        e.preventDefault();
        validation.handleSubmit();
        return false;
      }}
    >
      <ModalBody>
        <input type="hidden" id="id-field" />

        {fieldErrors.length > 0 && (
          <div className="mb-3">
            <Alert color="danger" className="material-shadow">
              {fieldErrors.map((error: any, index: any) => (
                <div key={index}>
                  <strong>{error.field}:</strong> {error.message}
                </div>
              ))}
            </Alert>
          </div>
        )}

        <div className="mb-3">
          <Label htmlFor="id-field" className="form-label">
            Name
          </Label>
          <Input
            name="name"
            id="name"
            className="form-control"
            placeholder="Enter name"
            type="text"
            validate={{
              required: { value: true },
            }}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.name || ""}
            invalid={
              validation.touched.name && validation.errors.name ? true : false
            }
          />
          {validation.touched.name && validation.errors.name ? (
            <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
          ) : null}
        </div>

        <div className="mb-3">
          <Label htmlFor="id-field" className="form-label">
            Acronym
          </Label>
          <Input
            name="acronym"
            id="acronym"
            className="form-control"
            placeholder="Enter acronym"
            type="text"
            validate={{
              required: { value: true },
            }}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.acronym || ""}
            invalid={
              validation.touched.acronym && validation.errors.acronym
                ? true
                : false
            }
          />
          {validation.touched.acronym && validation.errors.acronym ? (
            <FormFeedback type="invalid">
              {validation.errors.acronym}
            </FormFeedback>
          ) : null}
        </div>

        <div className="mb-3">
          <SelectRegion validation={validation} />
        </div>
      </ModalBody>

      <div className="modal-footer">
        <div className="hstack gap-2 justify-content-end">
          <button
            type="button"
            className="btn btn-light"
            onClick={() => {
              toggle();
            }}
          >
            Close
          </button>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading && (
              <Spinner
                color="light"
                size="sm"
                style={{ marginRight: "8px", marginBottom: "-1px" }}
              ></Spinner>
            )}
            {isUpdate ? "Update MDA" : "Add MDA"}
          </button>
        </div>
      </div>
    </Form>
  );
};

export default PaymentForm;
